import { useCustom } from './useCustom';
import { useLoadingScreen } from './useLoadingScreen';
import { History } from 'history';

export const usePathname = () => {
  const [state, setState] = useCustom();
  const { setLoading } = useLoadingScreen();

  const history = state._history;
  const pathname = state._pathname || history?.location.pathname || window.location.pathname;

  const setPathname = (_pathname: string) => {    
    if(_pathname === pathname || !history) return;
    
    history.push(_pathname);
    setState({ ...state, _pathname });
    setLoading(true);
  };

  const setHistory = (_history: History) => {
    setState({ ...state, _history });
  };

  return { pathname, setPathname, history, setHistory };
};